<template>
  <div class="toggle">
    <input type="checkbox" v-model="picked"  :id="`id-name--${itemID}`" name="set-name" class="switch-input" >
    <label @click.stop="toggle" :for="`id-name--${itemID}`" class="switch-label"></label>
  </div>
</template>

<script>

export default {
  name: 'adx-toggle',
  components: {

  },
  props: {
    valueLabel: {
      required: false
    },
    value: {
      required: false
    },
    itemID: {
      required: false
    }
  },
  data() {
    return {
      picked: '',
    }
  },
  computed: {

  },
  watch: {
    picked(newV, oldV) {
      // console.log(`val: `, this.value)
      // if (this.value.toLowerCase() !== this.picked.toLowerCase()){
      //   console.log(`masuk: `)
      //   this.$emit('statusChangedMobile', { id: this.itemID, status:value })
      // }
        // this.$emit('statusChangedMobile', { id: this.itemID, status:this.picked })
    }
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    this.picked = this.value
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    toggle() {
      this.$emit('statusChangedMobile', { id: this.itemID, status:this.picked })
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>